import styled from 'styled-components';

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
